import { FC, useContext, useState } from 'react';
import { SDKContext } from '../context/sdk';

type AsyncSDKCallback = (sdk: any) => Promise<any>;

type SABProps = { onClick: AsyncSDKCallback }

/**
 * This can take any of the same props as 
 * the design-system button.
 * However, the `onClick` callback receives the SDK
 * for ease of use.
 */
const SDKActionButton: FC<SABProps> = ({
  children,
  onClick,
  ...props
}) => {
  const [actionPending, setActionPending] = useState(false);

  const { error, sdk } = useContext(SDKContext);
  const disabled = Boolean(!sdk || error);

  return (
      <button
        style={{ minWidth: '24ch' }}
        disabled={disabled || actionPending}
        {...props}
        onClick={async () => {
          setActionPending(true);
          await onClick(sdk);

          setActionPending(false);
        }}
      >
        {children}
      </button>
  );
}

export default SDKActionButton;